<template>
	<v-col class="history-bonus">
		<template v-if="!printKomisi">
			<div class="d-flex justify-space-between">
				<div class="text-h6 cl-primary">Histori Komisi</div>
			</div>
			<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
				<v-icon small color="grey">mdi-database</v-icon>
				<div class="pl-2">Komisi</div>
				<div class="px-2">/</div>
				<div>Histori Komisi</div>
			</div>
			<div class="mt-5">
				<v-row justify="end">
					<v-col cols="12" sm="11" md="8" class="py-0 py-sm-3">
						<v-row justify="end">
							<v-col cols="12" sm="12" md="4">
								<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field placeholder="Pilih Bulan" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-xl date-no-border" hide-details :value="convertMonth(dateStart)"></v-text-field>
									</template>
									<v-date-picker locale="id" type="month" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" @change="changeDate" v-model="dateStart"></v-date-picker>
								</v-menu>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
							<v-tabs class="tabs-vo no-slider" v-model="tab_week">
								<v-tab :disabled="btn_loading" @click="changeWeek(1)">Minggu ke 1</v-tab>
								<v-tab :disabled="btn_loading" @click="changeWeek(2)">Minggu ke 2</v-tab>
								<v-tab :disabled="btn_loading" @click="changeWeek(3)">Minggu ke 3</v-tab>
								<v-tab :disabled="btn_loading" @click="changeWeek(4)">Minggu ke 4</v-tab>
							</v-tabs>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="!loading">
					<v-row v-if="listHistoryBonus.length > 0">
						<v-col cols="12" class="text-right">
							<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showPrintKomisi('1')">Print</v-btn>
						</v-col>
					</v-row>
					<v-row v-if="listHistoryBonus.length > 0">
						<v-col cols="12" class="pt-0 d-none d-md-block">
							<v-simple-table class="white-row table-vo table-history-bonus">
								<template v-slot:default>
									<thead class="">
										<tr>
											<th class="text-left">Hari</th>
											<th class="text-left">Tanggal</th>
											<th class="text-right">Start(Rp)</th>
											<th class="text-right">Sponsor(Rp)</th>
											<th class="text-right">Pasangan(Rp)</th>
											<th class="text-right">RO(Rp)</th>
											<th class="text-center">Total(Rp)</th>
										</tr>
									</thead>
									<tbody class="grey--text text--darken-3">
										<tr v-for="bonus in listHistoryBonus" :key="bonus.bonus_log_id">
											<td>{{ bonus.bonus_log_date | hari }}</td>
											<td>{{ bonus.bonus_log_date | tanggal }}</td>
											<td class="text-right">{{ bonus.bonus_log_start | toNumber }}</td>
											<td class="text-right">{{ bonus.bonus_log_sponsor | toNumber }}</td>
											<td class="text-right">{{ bonus.bonus_log_match | toNumber }}</td>
											<td class="text-right">{{ bonus.bonus_log_ro | toNumber }}</td>
											<td class="text-center">
												<div class="px-1 py-2 bg-primary-light cl-secondary font-weight-500 rounded-pill">{{ parseInt(bonus.bonus_log_match) + parseInt(bonus.bonus_log_ro) + parseInt(bonus.bonus_log_start) | toNumber }}</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>

						<v-col cols="12" class="pt-0 d-block d-md-none" v-for="bonus in listHistoryBonus" :key="bonus.bonus_log_id">
							<v-card elevation="1" class="hover-shadow pa-4">
								<div class="d-flex align-center justify-start font-size-10 mb-4">
									<span class="d-flex align-center black--text font-weight-500"><v-icon dense class="mr-2">mdi-calendar-outline</v-icon>{{ bonus.bonus_log_date | hari }}, {{ bonus.bonus_log_date | tanggal }}</span>
								</div>
								<div class="d-flex align-center justify-space-between font-size-10 mb-1">
									<span class="cl-secondary">Start (Rp)</span>
									<span class="cl-primary font-weight-500">{{ bonus.bonus_log_start | toNumber }}</span>
								</div>
								<div class="d-flex align-center justify-space-between font-size-10 mb-1">
									<span class="cl-secondary">Sponsor (Rp)</span>
									<span class="cl-primary font-weight-500">{{ bonus.bonus_log_sponsor | toNumber }}</span>
								</div>
								<div class="d-flex align-center justify-space-between font-size-10 mb-1">
									<span class="cl-secondary">Pasangan (Rp)</span>
									<span class="cl-primary font-weight-500">{{ bonus.bonus_log_match | toNumber }}</span>
								</div>
								<div class="d-flex align-center justify-space-between font-size-10 mb-1">
									<span class="cl-secondary">RO (Rp)</span>
									<span class="cl-primary font-weight-500">{{ bonus.bonus_log_ro | toNumber }}</span>
								</div>
								<div class="d-flex align-center justify-space-between font-size-11 mt-5">
									<span class="cl-secondary font-weight-600">Total (Rp)</span>
									<span class="cl-primary font-weight-600">{{ parseInt(bonus.bonus_log_match) + parseInt(bonus.bonus_log_ro) + parseInt(bonus.bonus_log_start) | toNumber }}</span>
								</div>
							</v-card>
						</v-col>
					</v-row>
					<div class="mt-5" v-if="listHistoryBonus.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="pt-3 text-center cl-secondary">Tidak ada data histori komisi yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="mt-4" v-if="loading">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<LoadData :loading="loading"></LoadData>
						</v-col>
					</v-row>
				</div>
			</div>
		</template>
		<template v-else>
			<PrintHistoriKomisi @action="showPrintKomisi" :dataPrint="dataPrint"></PrintHistoriKomisi>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import PrintHistoriKomisi from './PrintHistoriKomisi';

export default {
	components: {
		PrintHistoriKomisi
	},
	data() {
		return {
			loading: false,
			btn_loading: false,
			tab_week: 0,
			startDate: false,
			dateStart: moment().format("YYYY-MM"),
			start: '',
			end: '',
			monthYear: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
			dayStart: '1',
			dayEnd: '7',
			totalArray: [],
			activeWeek: 1,
			params: [],
			printKomisi: false,
			dataPrint: [],
		}
	},
	computed: {
		...mapState('bonus', ['listHistoryBonus', 'historyBonusPagination']),
	},
	methods: {
		...mapActions('bonus', ['getHistoryBonus']),

		async changeDate() {
			await this.changeWeek(this.activeWeek)
			this.getData()
		},
		changeWeek(week) {
			if (week == 1) {
				this.dayStart = '1'
				this.dayEnd = '7'
				this.getData()
			}
			if (week == 2) {
				this.dayStart = '8'
				this.dayEnd = '14'
				this.getData()
			}
			if (week == 3) {
				this.dayStart = '15'
				this.dayEnd = '21'
				this.getData()
			}
			if (week == 4) {
				this.dayStart = '22'
				this.dayEnd = '31'
				this.getData()
			}

			this.activeWeek = week
		},
		getData() {
			this.loading = true
			this.btn_loading = true
			this.params = []
			if (this.dateStart) {
				this.start = this.dateStart + '-' + this.dayStart
				this.end = this.dateStart + '-' + this.dayEnd

				let filter_date = {
					type: 'date',
					field: 'bonus_log_date',
					value: this.dateStart + '-' + this.dayStart + '::' + this.dateStart + '-' + this.dayEnd,
					comparison: 'bet',
				}
				this.params.push(filter_date)
			} else {
				this.start = this.monthYear + '-' + this.dayStart
				this.end = this.monthYear + '-' + this.dayEnd

				let filter_date = {
					type: 'date',
					field: 'bonus_log_date',
					value: this.monthYear + '-' + this.dayStart + '::' + this.monthYear + '-' + this.dayEnd,
					comparison: 'bet',
				}
				this.params.push(filter_date)
			}
			this.getHistoryBonus(this.queryString({sort: 'bonus_log_id', dir: 'ASC', page: '1', limit: '7', params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
				this.dataPrint = this.listHistoryBonus

				setTimeout(() => {
					this.btn_loading = false
				}, 400)
			}).catch(() => {
				setTimeout(() => {
					this.btn_loading = false
				}, 400)
			})
		},
		showPrintKomisi(val) {
			if (val == '1') {
				this.printKomisi = true
			} else {
				this.printKomisi = false
			}
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Histori Komisi`)
		this.getData()
	}
};
</script>

